interface Props {
  title: any;
  commitCount: number;
  completeCount: number;
  scoringCount: number;
  beforeScoringCount: number;
}
export const CollapsePanelHeader = ({
  title,
  commitCount,
  completeCount,
  scoringCount,
  beforeScoringCount,
}: Props) => {
  const allCount =
    commitCount + completeCount + scoringCount + beforeScoringCount;
  // const width = ((scoringCount + beforeScoringCount) / allCount) * 100;
  const width1 = (completeCount / allCount) * 100;
  const width2 = (commitCount / allCount) * 100;
  return (
    <div className="scoring_list_header">
      <h2 className="scoring_list_header_title">{title}</h2>
      <div className="scoring_list_header_graphWrapper">
        <div className="graph">
          <div className="graph2" style={{ width: width2 + "%" }}></div>
          <div className="graph1" style={{ width: width1 + "%" }}></div>
        </div>
        <p>
          提出済:{commitCount}&nbsp;&nbsp;完了:{completeCount}
          &nbsp;&nbsp;未完了:
          {scoringCount + beforeScoringCount}&nbsp;&nbsp;全件:{allCount}
        </p>
      </div>
    </div>
  );
};
